import { Bold as BoldToExtend } from '@tiptap/extension-bold';

export const Bold = BoldToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
